import React, { useState } from 'react';
import { Search, Filter, FileText, Calendar, Tag } from 'lucide-react';
import { regulationsData } from '../data/mock';

export const RegulationSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Semua');

  const categories = ['Semua', 'Undang-Undang', 'Peraturan Pemerintah', 'Peraturan Presiden', 'Peraturan Menteri'];

  const filteredRegulations = regulationsData.filter(reg => {
    const matchesSearch = reg.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         reg.number.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'Semua' || reg.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <section id="pencarian" className="py-20 px-4" style={{ background: 'var(--bg-page)' }}>
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Pencarian Peraturan</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Cari dan akses ribuan peraturan perundang-undangan Indonesia
          </p>
        </div>

        {/* Search Bar */}
        <div className="voice-card mb-8 max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 relative">
              <Search 
                size={20} 
                style={{ color: 'var(--text-muted)' }}
                className="absolute left-4 top-1/2 transform -translate-y-1/2"
              />
              <input
                type="text"
                placeholder="Cari berdasarkan nomor, judul, atau kata kunci..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-full border body-medium"
                style={{ 
                  borderColor: 'var(--border-input)',
                  background: 'var(--bg-card)',
                  outline: 'none'
                }}
                onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
              />
            </div>
            <button className="btn-primary flex items-center gap-2 px-6">
              <Search size={16} />
              <span>Cari</span>
            </button>
          </div>

          {/* Category Filter */}
          <div className="flex items-center gap-3 mt-6 pt-6 border-t" style={{ borderColor: 'var(--border-light)' }}>
            <Filter size={18} style={{ color: 'var(--text-muted)' }} />
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`btn-tag ${selectedCategory === category ? 'active' : ''}`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Results */}
        <div className="space-y-4">
          {filteredRegulations.map((regulation) => (
            <div 
              key={regulation.id} 
              className="voice-card hover-lift cursor-pointer flex flex-col md:flex-row gap-4"
            >
              <div className="w-16 h-16 rounded-lg flex items-center justify-center flex-shrink-0" 
                   style={{ background: 'var(--accent-orange-200)' }}>
                <FileText size={28} style={{ color: 'var(--accent-orange-400)' }} />
              </div>

              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-3 mb-2">
                  <span className="mono-text font-semibold" style={{ color: 'var(--text-primary)' }}>
                    {regulation.number}
                  </span>
                  <div className="flex items-center gap-2 px-2 py-1 rounded-full" 
                       style={{ background: 'var(--accent-grey-200)' }}>
                    <Tag size={12} style={{ color: 'var(--text-muted)' }} />
                    <span className="caption" style={{ color: 'var(--text-muted)' }}>
                      {regulation.category}
                    </span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Calendar size={12} style={{ color: 'var(--text-muted)' }} />
                    <span className="caption" style={{ color: 'var(--text-muted)' }}>
                      {regulation.year}
                    </span>
                  </div>
                </div>

                <h3 className="heading-3 mb-2">{regulation.title}</h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {regulation.summary}
                </p>
              </div>

              <button className="btn-secondary whitespace-nowrap h-fit">
                Lihat Detail
              </button>
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredRegulations.length === 0 && (
          <div className="text-center py-12">
            <p className="body-medium" style={{ color: 'var(--text-muted)' }}>
              Tidak ada peraturan yang ditemukan. Coba kata kunci lain.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
